// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_l6-1";
export var quotedThread = "_l6-0";